var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHelp = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.406
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.188 9.188a2.812 2.812 0 1 1 3.75 2.651A1.41 1.41 0 0 0 12 13.167v.943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.624a.351.351 0 1 1 0-.703M12 17.624a.351.351 0 1 0 0-.703"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M12 22.545c5.824 0 10.545-4.721 10.545-10.545S17.824 1.455 12 1.455 1.455 6.176 1.455 12 6.176 22.545 12 22.545Z"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    stroke: stroke,
    strokeWidth: 1.406
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.188 9.188a2.812 2.812 0 1 1 3.75 2.651A1.41 1.41 0 0 0 12 13.167v.943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.624a.351.351 0 1 1 0-.703M12 17.624a.351.351 0 1 0 0-.703"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M12 22.545c5.824 0 10.545-4.721 10.545-10.545S17.824 1.455 12 1.455 1.455 6.176 1.455 12 6.176 22.545 12 22.545Z"
  }))));
});
export default SvgIconHelp;
export const raw = __webpack_public_path__ + "static/media/IconHelp.0411677848fb27459f7c2438cf79b632.svg";